/*
 *   File : update-nominee.js
 *   Author : https://evoqins.com
 *   Description : Update nominee info modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { memo } from "react";
import { useNavigate } from "react-router-dom";

//custom component
import { PrimaryButton, SecondaryButton } from '../Buttons';

const UpdateNomineeInfoModal = (props) => {

    const navigate = useNavigate("");

    const _handleNavigateToManageNominee = () => {
        navigate("/profile", {
            state: {
                "active_tab": 2, // Manage nominee tab
                "update_nominee": true
            },
        });
        props.onClose();
    };

    return (
        <div className="modal fade"
            id="update-nominee"
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="Update Nominee  Modal Label"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content e-bg-lotion e-border-radius-24 e-addbank-box-shadow">
                    <div className="modal-header justify-content-between pt-4  px-4 pb-0 border-0">
                        <h6 className='e-font-16-res mb-2 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                            Update nominee
                        </h6>
                    </div>
                    <div className="modal-body px-4 pb-4 pt-0">
                        <p className='e-font-14-res mb-2 e-text-chinese-black e-font-16 e-alt-font-poppins e-font-weight-400 line-height-24px'>
                            According to the new SEBI guidelines, it is mandatory to provide a nominee along with the following details for all nominees: proof of identity (Aadhaar, PAN, driver's license, or passport), as well as contact and address information. Please ensure that the details provided match the official documents.
                        </p>
                        <p className='e-font-14-res mb-0 e-text-chinese-black e-font-16 e-alt-font-poppins e-font-weight-400 line-height-24px'>
                            Please update your nominee to proceed.
                        </p>
                        <div className="d-flex gap-3 mt-4">
                            <SecondaryButton name="No, Cancel"
                                dismiss="modal"
                                className="flex-fill py-2 e-bg-lotion e-font-16 e-text-charleston-green e-border-bright-gray"
                                onPress={props.onClose} />
                            <PrimaryButton name="Update nominee"
                                className="py-2 flex-fill"
                                dismiss="modal"
                                onPress={_handleNavigateToManageNominee} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(UpdateNomineeInfoModal);